import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=18fc4b4a&scoped=true"
import script from "./Workers.vue?vue&type=script&lang=js"
export * from "./Workers.vue?vue&type=script&lang=js"
import style0 from "./Workers.vue?vue&type=style&index=0&id=18fc4b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc4b4a",
  null
  
)

export default component.exports